import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ICreateCiBallotRequest } from '../../shared/models/ci/create-ci-ballot-request';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { CiBallotService } from '../../shared/services/ci-ballot.service';
import { IApiResponse } from '../../../../shared/models/api-response';
import { ToastService } from '../../../../shared/services/toast.service';
import { CommitteeService } from '../../../committees/shared/services/committee.service';
import { IFileUpload } from '../../../controls/files-upload/files-upload.component';


@Component({
    selector: 'app-cib-create',
    templateUrl: './cib-create.component.html',
    styleUrl: './cib-create.component.scss',
    standalone: false
})
export class CibCreateComponent {

  subscriptions: Subscription = new Subscription();

  supportDocumentFileUploadProgress: number[] = [0];
  commentTemplateFileUploadProgress: number[] = [0];

  hasInvalidFilesAttached: boolean = false;

  voteOptions = ['Agree','Disagree'];

  ballotForm = new FormGroup({
    referenceCtrl: new FormControl('', Validators.required),
    questionCtrl: new FormControl('', Validators.required),
    committeeCtrl: new FormControl('', Validators.required),
    startDateCtrl: new FormControl(null, Validators.required),
    endDateCtrl: new FormControl(null, Validators.required),
  });

  supportingDocumentFile: File | undefined;

  constructor(
    private _committeeService: CommitteeService,
    private _ciBallotService: CiBallotService,
    private _toastService: ToastService,
    private _router: Router
  ) {}

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  cancel() {
    this.ballotForm.reset();
  }

  handleSelectedDatesChange(selectedDatesForm: FormGroup): void {
    this.ballotForm.get('startDateCtrl')?.setValue(selectedDatesForm.get('startDateCtrl')?.value??null);
    this.ballotForm.get('endDateCtrl')?.setValue(selectedDatesForm.get('endDateCtrl')?.value??null);
  }

  addSupportingDocument(file: IFileUpload) {

    if(file.hasError) {
      this.hasInvalidFilesAttached = true;
      this.supportingDocumentFile = undefined;
      return;
    }
    else
    {
      this.hasInvalidFilesAttached = false;
    }
    if (!file.files[0]) return;
    this.supportingDocumentFile = file.files[0];
  }

  redirectToCreateBallotPage() {
    this._router.navigate(['/ballots/create']);
  }

  redirectToBallotPage() {
    this._router.navigate(['/ballots']);
  }

  createBallot() {
    let ciBallot: ICreateCiBallotRequest = {
      reference: this.ballotForm.get('referenceCtrl')?.value ?? '',
      question: this.ballotForm.get('questionCtrl')?.value ?? '',
      committeeCode: this.ballotForm.get('committeeCtrl')?.value ?? '',
      startDate: this.ballotForm.get('startDateCtrl')?.value ?? new Date(),
      endDate: this.ballotForm.get('endDateCtrl')?.value ?? new Date(),
      file: this.supportingDocumentFile ?? null,
    };

    this.subscriptions.add(this._ciBallotService.createBallot(ciBallot).subscribe({

      next: (event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            if (event.total) {
              this.supportDocumentFileUploadProgress[0] = Math.round(
                (100 * event.loaded) / event.total
              );
            }
            break;
          case HttpEventType.Response:
            this.supportDocumentFileUploadProgress[0] = 100;
            const apiResponse: IApiResponse<string> = event.body;
            if (apiResponse && apiResponse.success) {
              this._toastService.showSuccess("Committee Internal Ballot was successfully created.", "Committee Internal Ballot");
              this.redirectToBallotPage();
            } else {
              console.log('Error creating Committee Internal Ballot.', apiResponse.message);
              this._toastService.showError("Ballot not created due to an unexpected error. Please try again or contact IT Support if issue persists.", "Committee Internal Ballot");
            }
            break;
        }
      },
      error: (error) => {
        this.supportDocumentFileUploadProgress[0] = -1;
        this._toastService.showError("Ballot not created due to an unexpected error. Please try again or contact IT Support if issue persists.", "Committee Internal Ballot");
      },
    }));
  }

}
